module.exports = __webpack_public_path__ + "img/flooringInstallation.fd79f6e9.jpg";